import { NgModule } from '@angular/core';
import { PendingEditsComponent } from './pending-edits.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [TranslateModule],
  declarations: [PendingEditsComponent],
  exports: [PendingEditsComponent],
})
export class PendingEditsModule {}
